export var SamsungPayEventListenerEnumsObj = {
    PAYAIR_SAMSUNG_PAY_SDK_LISTENER: "PAYAIR_SAMSUNG_PAY_SDK_LISTENER",
};
